import { Reveal } from "@components/ui";
import journeyImage from "@assets/images/Rectangle-54@2x.png";
import teamImage from "@assets/images/Rectangle-541@2x.png";

const managementHighlights = [
  "Decades of combined experience in gas engineering, utility billing, and regulatory compliance.",
  "Certified Civil Defense contractors and ESMA-approved inspectors.",
  "Expertise in LPG/SNG system design, network optimization, and smart metering technologies.",
  "Commitment to continuous training and innovation under UAE HSE and ISO frameworks.",
];

export function AboutJourneySection() {
  return (
    <section className="w-full py-16 md:py-20 lg:py-[100px] px-5 md:px-10 lg:px-[180px] bg-[#f9f9fb]">
      <div className="w-full max-w-[1368px] mx-auto flex flex-col gap-12 md:gap-16">
        <Reveal direction="up">
          <div className="rounded-[24px] bg-white overflow-hidden shadow-[0_2px_16px_rgba(0,0,0,0.04)]">
            <div className="flex flex-col lg:flex-row">
              <div className="lg:w-[45%] overflow-hidden">
                <img
                  src={journeyImage}
                  alt="Our journey"
                  className="w-full h-[280px] lg:h-full object-cover"
                />
              </div>
              <div className="flex-1 p-8 md:p-10 lg:p-12 flex flex-col justify-center gap-5">
                <span className="text-[13px] md:text-[14px] font-semibold tracking-[0.1em] uppercase text-[#f24d2b]">
                  Our Story
                </span>
                <h2 className="text-[24px] md:text-[32px] lg:text-[40px] font-semibold tracking-[-0.04em] text-[#122d63] leading-[1.2]">
                  Journey & Group Affiliation
                </h2>
                <p className="text-[15px] md:text-[17px] lg:text-[19px] tracking-[-0.02em] text-[#62636c] leading-[1.7]">
                  GAZ is part of the <strong className="text-[#090d2c]">Contra Group of Companies</strong>, a multi-sector
                  conglomerate established in Abu Dhabi in 1960 and re-founded
                  in 2006 by Yazan Bin Mohammad. The group operates across Real Estate, Energy Management,
                  Technology, Education, and Facility Services — employing over
                  1,200 staff across the Middle East, Europe, and Asia.
                </p>
                <p className="text-[15px] md:text-[17px] lg:text-[19px] tracking-[-0.02em] text-[#62636c] leading-[1.7]">
                  GAZ serves as the group's specialized entity for gas
                  distribution, metering, and utility billing solutions.
                </p>
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal direction="up">
          <div className="rounded-[24px] bg-white overflow-hidden shadow-[0_2px_16px_rgba(0,0,0,0.04)]">
            <div className="flex flex-col lg:flex-row-reverse">
              <div className="lg:w-[40%] overflow-hidden">
                <img
                  src={teamImage}
                  alt="Management team"
                  className="w-full h-[280px] lg:h-full object-cover"
                />
              </div>
              <div className="flex-1 p-8 md:p-10 lg:p-12 flex flex-col justify-center gap-6">
                <span className="text-[13px] md:text-[14px] font-semibold tracking-[0.1em] uppercase text-[#f24d2b]">
                  Leadership
                </span>
                <h2 className="text-[24px] md:text-[32px] lg:text-[40px] font-semibold tracking-[-0.04em] text-[#122d63] leading-[1.2]">
                  Management Team Highlights
                </h2>
                <div className="flex flex-col gap-4">
                  {managementHighlights.map((item, i) => (
                    <div key={i} className="flex items-start gap-3">
                      <div className="w-6 h-6 min-w-6 rounded-full bg-[#f24d2b]/10 flex items-center justify-center mt-0.5">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                          <path d="M9 12l2 2 4-4" stroke="#f24d2b" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </div>
                      <p className="text-[15px] md:text-[17px] lg:text-[19px] tracking-[-0.02em] text-[#62636c] leading-[1.6]">
                        {item}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
